import CryptoJS from 'crypto-js';

// 단순하고 일관된 해싱 방식
export const hashPassword = (password, username = '', action = 'login') => {
    try {
        // 환경변수에서 마스터 솔트 가져오기 (.env의 MASTER_SALT 사용)
        const masterSalt = process.env.MASTER_SALT;
        
        // 사용자별 고유 솔트 생성 (단순하게)
        const userSalt = CryptoJS.SHA256(`${masterSalt}${username}${action}`).toString(CryptoJS.enc.Hex);
        
        // PBKDF2로 최종 해싱 (일관된 방식)
        const hashedPassword = CryptoJS.PBKDF2(password, userSalt, {
            keySize: 256/32, // 32바이트 (64자 hex)
            iterations: 10000,
            hasher: CryptoJS.algo.SHA256
        }).toString(CryptoJS.enc.Hex);
        
        return hashedPassword;
    } catch (error) {
        console.error('비밀번호 해싱 오류:', error);
        throw new Error('비밀번호 처리 중 오류가 발생했습니다.');
    }
};

/**
 * 메모리에서 민감한 데이터를 안전하게 제거하는 함수
 */
export const secureCleanup = (obj, fields) => {
    fields.forEach(field => {
        if (obj[field]) {
            obj[field] = new Array(obj[field].length + 1).join('*');
            delete obj[field];
        }
    });
};

/**
 * 비밀번호 강도 검증 (클라이언트 측)
 */
export const validatePasswordStrengthClient = (password) => {
    const checks = {
        length: password.length >= 8,
        lowercase: /[a-z]/.test(password),
        number: /[0-9]/.test(password),
        special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
        noRepeats: !/(.)\1{2,}/.test(password)
    };
    
    const passedChecks = Object.values(checks).filter(Boolean).length;
    const strength = Math.min(passedChecks, 5);
    
    const feedback = [];
    if (!checks.length) feedback.push('최소 8자 이상');
    if (!checks.lowercase) feedback.push('소문자 포함');
    if (!checks.number) feedback.push('숫자 포함');
    if (!checks.special) feedback.push('특수문자 포함');
    if (!checks.noRepeats) feedback.push('연속 문자 제한');
    
    return { strength, feedback, isValid: strength >= 4 };
};
